import React from "react";

const PageHeader = ({ title, subtitle }) => {
  return (
    <section className="bg-gradient-to-b from-[#181818] to-[#0f0f10] py-16 border-b border-[#2a2a2a]">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <h1 className="font-display text-4xl md:text-6xl text-[#f5f1e8] tracking-wide fade-up">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-4 text-[#c8bfae] font-serif-italic text-lg">{subtitle}</p>
        )}
        <div className="mt-6 flex justify-center">
          <div className="w-24 h-1 bg-[#e8a13a]" />
        </div>
      </div>
    </section>
  );
};

export default PageHeader;
